import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {getGameTitle} from '../../../../../helpers/eventHelpers';
import {getText} from '../../../../../helpers/localization';
import OpenBet from '../../../components/openBet';
import OpenAccaBet from "../../../components/openAccaBet";
import {getRoundedOdds} from "../helpers/matchdayHelper";
import {UNDER_OVER_25} from '../constants/marketTypes';
import {OPERATOR} from "../../../../../constants/operator";

const mapStateToProps = (state, ownProps) => {
    return {
        openBetsList: state.vpp.openBetsList
    };
};

class OpenBetMatchday extends Component {

    constructor(props) {
        super(props);
        this.state = {
            openBetsList: props.store.getState().vpp.openBetsList
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();
        this.setState({
            openBetsList: storeData.vpp.openBetsList
        });
    }

    render() {
        let homeTeam = getText("Matchday_" + this.props.betSelection.bets[0].event.teamOne, this.props.store);
        let awayTeam = getText("Matchday_" + this.props.betSelection.bets[0].event.teamTwo, this.props.store);

        let name = isNaN(this.props.betSelection.bets[0].market.selection)
            ? getText(this.props.betSelection.bets[0].market.selection, this.props.store, [homeTeam, awayTeam])
            : this.props.betSelection.bets[0].market.selection;
        let names = [name];


        let title = `${homeTeam} ${getText('VS', this.props.store)} ${awayTeam}`;
        let eventName = this.props.betSelection.bets.length == 1 ? getGameTitle(title, this.props.betSelection.bets[0].event.eventTimeDate, this.props.store.getState().vpp.systemLanguage) : '';
        let betType = getText(this.props.betSelection.bets[0].betType.name === UNDER_OVER_25.name
            ? 'UNDER_OVER_2_5' : this.props.betSelection.bets[0].betType.name, this.props.store, [homeTeam, awayTeam]);
        let odd = getRoundedOdds(this.props.betSelection.bets, true);
        odd = isNaN(odd) || odd > OPERATOR.maxAccumulatorOdds ? 0.00 : odd;
        let betSlip = this.props.betSelection.bets.length == 1 ? (<OpenBet
            store={this.props.store}
            index={this.props.index}
            betSelection={this.props.betSelection}
            names={names}
            betType={betType}
            odd={odd}
            eventName={eventName}
            leagueDay={this.props.betSelection.bets[0].event.leagueDay}
            isEnabled={this.props.isEnabled}
            openBetFocusCallback={this.props.openBetFocusCallback}/>) : (<OpenAccaBet
            store={this.props.store}
            index={this.props.index}
            betSelection={this.props.betSelection}
            odd={odd}
            isEnabled={OPERATOR.accaBetAutoFocusEnabled ? true : this.props.isEnabled}
            openBetFocusCallback={this.props.openBetFocusCallback}/>);

        return (
            <Fragment>
                {betSlip}
            </Fragment>

        );
    }
}

export default connect(mapStateToProps)(OpenBetMatchday);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/matchday/components/openBetMatchday.js